import CoreuiController from "../lib/coreui-controller"
import Offcanvas from "../coreui/offcanvas"

export default class CoreuiOffcanvasController extends CoreuiController {
  static Component = Offcanvas
}
